export default __webpack_public_path__ + "static/media/c1.e4dcf092.png";